import React from 'react'
import classNames from 'classnames'
import { transformDate } from 'src/utils/helpers/MessagesHelpers'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import HorizontalLine from 'src/components/Elements/HorizontalLine'

const TimeframeDivider = ({ timeframe }) => (
  <div
    className={classNames(
      generalStyles.flexRow,
      generalStyles.alignVertical,
      generalStyles.mb31,
      generalStyles.mt10
    )}
  >
    <div
      className={classNames(generalStyles.flexColumn, generalStyles.fullFlex)}
    >
      <HorizontalLine fullWidth={true} color={'c03silvere8e8e8'} />
    </div>
    <div className={classNames(generalStyles.ml32, generalStyles.mr32)}>
      <span className={fontStyles.pxsmallboldlsssgraphik12pt}>
        {transformDate(timeframe)}
      </span>
    </div>
    <div
      className={classNames(generalStyles.flexColumn, generalStyles.fullFlex)}
    >
      <HorizontalLine fullWidth={true} color={'c03silvere8e8e8'} />
    </div>
  </div>
)

export default TimeframeDivider
